import React, { useRef } from 'react';
import Button from '../components/Button';
import UIActions from '../ui/UIActions';
import handleApolloError from '../utils/error/handleApolloError';
import styles from './SettingsImageEditor.module.scss';
import { useAppDispatch } from '../app/redux/useAppSelector';

interface SettingsImageEditorProps {
  children: React.ReactNode;
  onUpload: (file: File) => Promise<void>;
}

const SettingsImageEditor = ({
  children,
  onUpload,
}: SettingsImageEditorProps) => {
  const dispatch = useAppDispatch();
  const input = useRef<HTMLInputElement | null>(null);
  const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.currentTarget.files?.[0];
    if (!file) {
      return;
    }
    onUpload(file).catch((e) =>
      handleApolloError(e, 'VALIDATION', () =>
        dispatch(
          UIActions.pushToast({
            level: 'error',
            title: 'Oops',
            message:
              'Uploaded image was not supported, please try again with a different file.',
          }),
        ),
      ),
    );
    // eslint-disable-next-line no-param-reassign
    event.currentTarget.value = '';
  };

  return (
    <div className={styles.container}>
      <div>{children}</div>
      <div>
        <input
          accept="image/jpeg,image/png"
          className={styles.input}
          onChange={handleUpload}
          ref={input}
          type="file"
          aria-label="Upload image"
        />
        <Button onClick={() => input.current?.click()} variant="secondary">
          Change
        </Button>
      </div>
    </div>
  );
};

export default SettingsImageEditor;
